import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=5f1d2d90&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=5f1d2d90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d2d90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1d2d90')) {
      api.createRecord('5f1d2d90', component.options)
    } else {
      api.reload('5f1d2d90', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=5f1d2d90&scoped=true", function () {
      api.rerender('5f1d2d90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/orderInfo.vue"
export default component.exports